import {
  AppStateUserActivity,
  UserActivityActionType,
  USER_ACTIVITY,
} from "./types";

const initialState: AppStateUserActivity = {
  isRunning: false,
};

const activityReducer = (
  state = initialState,
  action: UserActivityActionType
): AppStateUserActivity => {
  switch (action.type) {
    case USER_ACTIVITY.START:
      return {
        ...state,
        isRunning: true,
      };
    case USER_ACTIVITY.STOP:
      return {
        ...state,
        isRunning: false,
      };
    default:
      return state;
  }
};
export default activityReducer;
